
import { Button } from "@/components/ui/button";
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { Plus } from "lucide-react";
import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { DeliveryDriverDialog } from "./DeliveryDriverDialog";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

export const DeliveryDriversList = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedDriver, setSelectedDriver] = useState<any>(null);

  const { data: drivers, refetch } = useQuery({
    queryKey: ["delivery-drivers"],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("delivery_drivers")
        .select("*")
        .order("name");

      if (error) throw error;
      return data;
    },
  });

  const handleToggleActive = async (driverId: string, currentStatus: boolean) => {
    try {
      const { error } = await supabase
        .from("delivery_drivers")
        .update({ is_active: !currentStatus })
        .eq("id", driverId);

      if (error) throw error;
      
      toast.success("Statut du livreur mis à jour");
      refetch();
    } catch (error) {
      console.error("Erreur lors de la mise à jour du statut:", error);
      toast.error("Erreur lors de la mise à jour du statut");
    }
  };

  return (
    <div className="space-y-4">
      <div className="flex justify-end">
        <Button onClick={() => {
          setSelectedDriver(null);
          setIsDialogOpen(true);
        }}>
          <Plus className="h-4 w-4 mr-2" />
          Ajouter un livreur
        </Button>
      </div>

      <Card>
        <CardContent className="p-0">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Nom</TableHead>
                <TableHead>Type</TableHead>
                <TableHead>Contact</TableHead>
                <TableHead>Actif</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {drivers?.map((driver) => (
                <TableRow
                  key={driver.id}
                  className="cursor-pointer hover:bg-muted/50"
                  onClick={() => {
                    setSelectedDriver(driver);
                    setIsDialogOpen(true);
                  }}
                >
                  <TableCell>{driver.name}</TableCell>
                  <TableCell>
                    {driver.driver_type === "company" ? "Entreprise" : "Freelance"}
                  </TableCell>
                  <TableCell>{driver.contact}</TableCell>
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <Switch
                      checked={driver.is_active}
                      onCheckedChange={() => handleToggleActive(driver.id, driver.is_active)}
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>

      <DeliveryDriverDialog
        open={isDialogOpen}
        onOpenChange={setIsDialogOpen}
        driver={selectedDriver}
        onSuccess={() => {
          setIsDialogOpen(false);
          refetch();
        }}
      />
    </div>
  );
};
